import intl from 'react-intl-universal';
import { enLocale, getTranslations, supportedLocales } from './utils/LocaleUtil';

export default (locale?: string) => {
  let currentLocale = intl.determineLocale({ urlLocaleKey: 'lang' });

  if (!supportedLocales.find(({ value }) => value === currentLocale)) {
    currentLocale = enLocale;
  }

  currentLocale = locale || currentLocale;

  return intl.init({ currentLocale, locales: { [currentLocale]: getTranslations(currentLocale) } });
};
